'use strict';
// Stub required by ycomponent JS loader (load_js=true on faqsearch setting).
// Search is handled by the Vue component FaqSearchGroupSearch loaded via assets loader.
